<!--
单元格长内容展示
主要是考虑过长时省略
-->
<template>
  <el-tooltip v-if="!isEmptyObject(value) && value != '-'" class="item" placement="top-start" :manual="!showTooltip">
    <div slot="content" style="max-width: 500px;">{{ txt(value) }}</div>

    <div class="lc-ellipsis-text lc-cell-long-text" :style="`-webkit-line-clamp: ${rows}; height: ${rowsHeight}px`">{{ txt(value) }}</div>
  </el-tooltip>
  <div v-else>-</div>
</template>
<script>
export default {
  props: {
    /**
     * 展示的文本
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * 展示的行数
     * 该行数不进行省略
     */
    rows: {
      type: Number,
      default: 1
    },
    /**
     * 展示 Tooltip
     */
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * 总行高度
     * 默认每一行 15px，在 lc-ellipsis-text 有定义
     *
     * @returns {number} 像素
     */
    rowsHeight() {
      return this.rows * 15
    }
  }
}
</script>
